export enum ResultItemType {
    LOCATION = 'location',
    COUNTRY = 'country'
}
